import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';

interface OnlineStatusProps {
  isOnline: boolean;
  lastSeenAt?: string | null;
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
}

const OnlineStatus: React.FC<OnlineStatusProps> = ({
  isOnline,
  lastSeenAt,
  size = 'small',
  showTooltip = true,
}) => {
  const sizeMap = {
    small: 8,
    medium: 10,
    large: 12,
  };

  const dotSize = sizeMap[size];

  const getTooltipText = () => {
    if (isOnline) return 'En ligne';
    if (lastSeenAt) {
      try {
        return `Vu ${formatDistanceToNow(new Date(lastSeenAt), { addSuffix: true, locale: fr })}`;
      } catch {
        return 'Hors ligne';
      }
    }
    return 'Hors ligne';
  };

  const dot = (
    <Box
      sx={{
        width: dotSize,
        height: dotSize,
        borderRadius: '50%',
        backgroundColor: isOnline ? '#4caf50' : '#9e9e9e',
        border: '2px solid white',
        boxShadow: isOnline ? '0 0 4px #4caf50' : 'none',
      }}
    />
  );

  if (!showTooltip) return dot;

  return (
    <Tooltip title={getTooltipText()} placement="top">
      {dot}
    </Tooltip>
  );
};

export default OnlineStatus;
